import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import {
  InWorkJobs,
  JobFor,
  JobsDataType,
  Member,
  Organization,
  OrganizationCreate,
  jobForDeliveryCenter,
} from '../../../components/ types';
import { WorkspacesItemProps } from '../../../components/Cabinet/Main';
import { RequestData, api } from '../../../utils';
import { basicRequestDelete } from '../../Requests/basicRequestDelete';
import { basicRequestGet } from '../../Requests/basicRequestGet';
import { basicRequestPatch } from '../../Requests/basicRequestPatch';
import { basicRequestPost } from '../../Requests/basicRequestPost';

export type IWorkspace = {
  _id: string;
  name: string;
  category: string;
  theme: {
    _id: string;
    category: string;
  };

  // TODO:
  invites: any[];
  members: any[];
};

export type IWorkspaceCreate = {
  name: string;
};

export class WorkspacesStoreActionsClass {
  @observable modalSettingOpen: boolean = false;
  @observable modalSettingWorkspaceId: string | null = null;

  @observable nameModal: string = '';

  @observable isModalOpenAdd: boolean = false;

  @observable loadingError: boolean = false;
  @observable addError: boolean = false;

  @observable loading: boolean = false;
  @observable addloading: boolean = false;

  @observable getloading: boolean = false;
  @observable getError: boolean = false;

  @observable dataListWork: IWorkspace[] = [];

  @observable data: WorkspacesItemProps = {};
  @observable members: Record<string, Member> = {};
  @observable inWorkJobs: InWorkJobs = {};

  constructor() {
    // makeObservable(this);
    makeAutoObservable(this);
  }

  @action setMembers(members: Member[]) {
    const res: Record<string, Member> = {};
    for (const member of members) {
      res[member.userId._id] = member;
    }
    this.members = res;
  }

  @action setInWorkJobs(inWorkJobs: { inWorkJobs: InWorkJobs }) {
    this.inWorkJobs = inWorkJobs.inWorkJobs;
  }

  @action
  modalSettingShow(workspaceId: string) {
    this.modalSettingWorkspaceId = workspaceId;
    this.modalSettingOpen = true;
  }

  @action
  modalSettingClose() {
    this.modalSettingWorkspaceId = null;
    this.modalSettingOpen = false;
  }

  @action
  async addWorkspaces(name: string) {
    console.log('addWorkspaces');
    this.addloading = true;
    this.addError = false;
    try {
      await basicRequestPost('/workspaces', { name });
    } catch (error) {
      console.error('addWorkspaces|error=', error);
      this.addError = true;
    } finally {
      this.addloading = false;
    }
  }

  @action
  async getWorkspaces(_id: string, options?: { hiddenLoading: boolean }) {
    const hiddenLoading = options?.hiddenLoading !== undefined ? options.hiddenLoading : false;

    console.log('getWorkspacesId');

    if (!hiddenLoading) {
      this.getloading = true;
      this.data = {};
    }

    this.getError = false;

    try {
      const res = await basicRequestGet('/workspaces/' + _id);
      runInAction(() => {
        this.data = res.data;
      });
    } catch (error) {
      console.error('getWorkspacesId|error=', error);
      this.getError = true;
    } finally {
      runInAction(() => {
        this.getloading = false;
      });
    }
  }

  @action
  async getList() {
    console.log('getList workspaces');
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.loadingError = false;
    this.dataListWork = [];
    try {
      const res = await basicRequestGet('/workspaces');
      console.log('---- ww|getList|res.data=', res.data);
      runInAction(() => {
        this.dataListWork = res.data.data as IWorkspace[];
        console.log(res, 'dataListWork');
      });
    } catch (error) {
      console.error('getList workspaces|error=', error);
      this.loadingError = true;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  @action
  async deleteWorkspaces(_id: string) {
    const index = this.dataListWork.findIndex((obj) => obj._id === _id);
    console.log('deleteChallenge|index=', _id);
    if (index === -1) {
      console.error('deleteChallenge|index !== -1');
      throw 'Remove error';
    }
    await basicRequestDelete('/workspaces/' + _id);
    this.dataListWork = this.dataListWork.filter((obj) => obj._id !== _id);
    if (this.data?._id === _id) {
      this.data = {};
    }
  }

  workspaces = new RequestData<[], IWorkspace[]>(async () => await api('workspaces'), []);

  createWorkspace = new RequestData<[IWorkspaceCreate], IWorkspace>(
    async (params) => await api.post('workspaces', { ...params })
  );

  workspaceById = new RequestData<[string], IWorkspace | null>(
    async (workspaceId) => await api(`workspaces/${workspaceId}`),
    null
  );

  inviteAdd = new RequestData<[string, string], IWorkspace>(
    async (workspaceId: string, email: string) =>
      await api.post(`workspaces/${workspaceId}/invites`, { workspaceId, email })
  );

  inviteDel = new RequestData<[string, string], IWorkspace>(
    async (workspaceId: string, _id: string) =>
      await api.delete(`workspaces/${workspaceId}/invites/${_id}`)
  );

  inviteReSend = new RequestData<[string, string], IWorkspace>(
    async (workspaceId: string, _id: string) =>
      await api.get(`workspaces/${workspaceId}/invites/${_id}/emailSend`)
  );

  membersGet = new RequestData<[string], Member[]>(async (workspaceId: string) => {
    const res = await api.get(`/workspaces/${workspaceId}/members`);
    this.setMembers(res.data);
    return res;
  });

  memberDel = new RequestData<[string, string], IWorkspace>(
    async (workspaceId: string, _id: string) =>
      await api.delete(`/workspaces/${workspaceId}/members/${_id}`)
  );

  getJobsById = new RequestData<[string, number], JobsDataType[]>(
    async (workspaceId: string, jobId: number) =>
      await api.get(`/workspaces/${workspaceId}/jobs/findByJobId/${jobId}`)
  );

  getJobsByJobFor = new RequestData<[string, JobFor], { data: JobsDataType[] }>(
    async (workspaceId: string, jobFor: JobFor) =>
      await api.get(`/workspaces/${workspaceId}/jobs/getDeliveryCenterJobs/${jobFor}`)
  );

  getJobsInWork = new RequestData<[string], { inWorkJobs: InWorkJobs }>(
    async (workspaceId: string) => await api.get(`/workspaces/${workspaceId}/jobs/inWork`)
  );

  @action
  async addJobForDeliveryCenter(workspaceId: string, deliveryJob: jobForDeliveryCenter) {
    console.log('addJobForDeliveryCenter');
    this.addloading = true;
    this.addError = false;
    try {
      await basicRequestPost(
        `/workspaces/${workspaceId}/jobs/createJobDeliveryCenter`,
        deliveryJob
      );
    } catch (error) {
      console.error('addJobForDeliveryCenter|error=', error);
      throw error;
      this.addError = true;
    } finally {
      this.addloading = false;
    }
  }

  @action
  async updateJobForDeliveryCenter(
    workspaceId: string,
    id: string,
    deliveryJob: jobForDeliveryCenter
  ) {
    console.log('addJobForDeliveryCenter');
    this.addloading = true;
    this.addError = false;
    try {
      await basicRequestPatch(
        `/workspaces/${workspaceId}/jobs/${id}/updateJobDeliveryCenter`,
        deliveryJob
      );
    } catch (error) {
      console.error('updateJobForDeliveryCenter|error=', error);
      throw error;
      this.addError = true;
    } finally {
      this.addloading = false;
    }
  }

  organizations = new RequestData<[string], { data: Organization[] }>(
    async (id) => await api.get(`/workspaces/${id}/organizations`),
    { data: [] }
  );

  addOrganization = new RequestData<[string, OrganizationCreate], {}>(
    async (id, body) => await api.post(`/workspaces/${id}/organizations`, { ...body })
  );

  updateOrganization = new RequestData<[string, string, OrganizationCreate], {}>(
    async (id, orgId, body) =>
      await api.patch(`/workspaces/${id}/organizations/${orgId}`, { ...body })
  );

  deleteOrganization = new RequestData<[string, string], {}>(
    async (id, orgId) => await api.delete(`/workspaces/${id}/organizations/${orgId}`)
  );
}
